import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.createClient('widgetBff', { headers })
}

export const getAgentsFilter = (limit = 3) =>
  getClient()
    .then(client =>
      client.get('agents/', {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data.filter(a => a.active).slice(0, limit))

export const getAgentsOnlineCount = () =>
  getClient()
    .then(client =>
      client.get(`agents/filter/status/online/count`, {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data)

export const getOnlineAgents = () =>
  getClient()
    .then(client =>
      client.get(`agents/filter/status/online`, {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data)

export const getGroupAgentsOnlineCount = groupId =>
  getClient()
    .then(client =>
      client.get(`agents/filter/group/${groupId}/status/online/count`, {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data)

export const getAvailableAgents = () =>
  getClient()
    .then(client =>
      client.get('agents/filter/available', {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data)

export const countAvailableAgents = () =>
  getClient()
    .then(client =>
      client.get('agents/filter/available/count', {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data)

export const countAvailableAgentsByGroupId = groupId =>
  getClient()
    .then(client =>
      client.get(`agents/filter/group/${groupId}/available/count`, {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data)

export const getAgentAvailabilityById = agentId =>
  getClient()
    .then(client =>
      client.get(`agents/${agentId}`, {
        headers: getParameterHeaders()
      })
    )
    .then(response => response.data.availability)
